import { Component, OnInit, Input, ViewChild} from '@angular/core';
import { NgForm } from '@angular/forms';

// service
import { ApiService } from 'src/app/shared/service/api.service';

// Plugin
import { ModalDirective } from 'ngx-bootstrap/modal';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-subscribe',
  templateUrl: './subscribe.component.html'
})
export class SubscribeComponent implements OnInit {

  @ViewChild('modal', { static: false }) modal: ModalDirective;
  @Input() versi = '1';
  isLang;
  isModalShown = false;

  constructor( private apiService: ApiService ) { }

  ngOnInit(): void {
    // MultiLanguage
    this.isLang = this.apiService.isLang();
  }

  showModal(): void {
    this.isModalShown = true;
  }

  onHidden(): void {
    this.isModalShown = false;
  }

  onSubscribe(subsForm: NgForm){
    let body = subsForm.value;
    if(body.email){
      this.apiService.postDataApi('subscribeNewsletter', body).subscribe(
        data => { 
          Swal.fire({
            icon: 'success',
            text:  data.message
          })
        },
        error => { 
          Swal.fire({
            icon: 'error',
            text: 'Failed, please try again!'
          })
        }
      ); 
      subsForm.resetForm();
    }
  }

}
